import React, { createRef } from "react";
import {
  Input,
  DatePicker,
  Select,
  Table,
  Button,
  Typography,
  Space,
  Row,
  Col,
  Checkbox,
  Dropdown,
  Modal,
  Image,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";

import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import StoppageReportStore from "../store/StoppageReportStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import ListTable from "./ListTable";
import VehicleStore from "../store/VehicleStore";

import dayjs from "dayjs";
import MapForVehiclePosition from "./MapForVehiclePosition";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import XML from "../assets/images/NewDesign/XML.svg";
import CSV from "../assets/images/NewDesign/CSV.svg";
import PythonMessageAlert from "./PythonMessageAlert";
import conf from "../config";
import { Link } from "react-router-dom";
import { invalidateCache } from "../store/cacheStore";


const { RangePicker } = DatePicker;
const { Text } = Typography;
const { Option } = Select;
class StoppageReportList extends React.Component {
  constructor(props, context) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleTotalTableChange = this.handleTotalTableChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.stoppageReportStore = new StoppageReportStore();
    this.vehicleStore = new VehicleStore();
    this.pythonMessageRef = createRef();

    this.ExportOption = [{
      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          {" "}
          <Image
            style={{ height: "18px", width: "18px", borderRadius: "0px" }}
            src={Excel}
          ></Image>
          {context.translate("_EXPORT_AS_EXCEL_")}
        </div>
      ),
      key: "excel",
    }]

    // if (conf.currentFlavor !=="nodeui"){
    //   this.ExportOption.push({
    //     label: (
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           gap: "5px",
    //         }}
    //       >
    //         {" "}
    //         <Image
    //           style={{ height: "18px", width: "18px", borderRadius: "0px" }}
    //           src={CSV}
    //         ></Image>
    //         {context.translate("_EXPORT_AS_CSV_")}
    //       </div>
    //     ),
    //     key: "csv",
    //   },
    //   {
    //     label: (
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           gap: "5px",
    //         }}
    //       >
    //         {" "}
    //         <Image
    //           style={{ height: "18px", width: "18px", borderRadius: "0px" }}
    //           src={XML}
    //         ></Image>
    //         {context.translate("_EXPORT_AS_XML_")}
    //       </div>
    //     ),
    //     key: "xml",
    //   })
    // }

    this.ExportOption.push({
      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          {" "}
          <Image
            style={{ height: "18px", width: "18px", borderRadius: "0px" }}
            src={PDF}
          ></Image>
          {context.translate("_EXPORT_AS_PDF_")}
        </div>
      ),
      key: "pdf",
    })

    this.state = {
      loading: false,
      pageSize: 50,
      pageNo: 1,
      offset: 0,
      limit: 50,
      loadData: 0,
      companyId: "",
      selectedVehicles: [],
      selectAllVehicles: false,
      allVehicle: false,
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      interval: 0,
      modalVisible: false,
      column: "",
      filter: "",
      userId: "",
      modalInfoObj: {},
      viewMap: false,
      Notcompany: false,
      Notasset: false,
      Notdate: false,
      Notinterval: false,

      showMonthPopup: false,
      vehicleObj: false,
      heading: "",
      showTable: true,
      showtotaltable: false,
      reportmessage: "",
      totalPageSize: 50,
      totalPageNo: 1,
      selectedColumns: [
        {
          // title: "Vehicle No",
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
          dataIndex: "vehicleNo",
          width: 100,
          key: "vehicleNo",
          ellipsis: { showTitle: true },
          render: (vehicleNo) => (
            <Tooltip placement="topLeft" title={vehicleNo}>
              {vehicleNo}
            </Tooltip>
          ),
        },
        {
          // title: "Driver",
          title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"),
          dataIndex: "name",
          width: 80,
          key: "name",
          ellipsis: { showTitle: true },
          render: (name) => (
            <Tooltip placement="topLeft" title={name}>
              {name}
            </Tooltip>
          ),
        },

        {
          // title: "Address",
          title: context.translate("_FLEET_DASHBORD_NEWPOI_ADDRESS_"),
          dataIndex: "stopLocation",
          width: 150,
          key: "stopLocation",
          ellipsis: { showTitle: true },
          render: (stopLocation) => (
            <Tooltip placement="topLeft" title={stopLocation}>
              {stopLocation}
            </Tooltip>
          ),
        },
        {
          // title: "Halted From",
          title: context.translate("_HALTED_FROM_"),
          dataIndex: "arrivalTime",
          width: 110,
          key: "arrivalTime",
          ellipsis: { showTitle: true },
        },
        {
          // title: "Halted Till",
          title: context.translate("_HALTED_TILL_"),
          dataIndex: "departureTime",
          width: 110,
          key: "departureTime",
          ellipsis: { showTitle: true },
        },
        {
          // title: "Time Stopped",
          title: context.translate("_FLEET_REPORTS_STOPREPORT_TIMESTOP_"),
          dataIndex: "stopTime",
          ellipsis: { showTitle: true },
          width: 80,
          key: "stopTime",
        },
        {
          // title: "Customer Name",
          title: context.translate("_CUSTOMER_NAME_"),
          dataIndex: "zoneName",
          width: 120,
          key: "customername",
          ellipsis: { showTitle: true },
          render: (customername) => (
            <Tooltip placement="topLeft" title={customername}>
              {customername}
            </Tooltip>
          ),
        },
        {
          // title: "View On Map",
          title: context.translate("_FLEET_SERVICE_POILIST_VIEWMAP_"),
          dataIndex: "viewonmap",
          width: 50,
          key: "viewonmap",
          ellipsis: { showTitle: true },
          render: (value, obj) => {
            return (
              <>
                <Link>
                  <Image
                    src={require("../assets/images/mapIcon/gps_icon.png")}
                    width={25}
                    height={25}
                    onClick={async () => {
                      await this.setState({
                        vehicleObj: {
                          ...obj,
                          icon: "map-car-icon-green.png",
                          latitude: obj.stopLat,
                          longitude: obj.stopLon,
                        },
                        // heading: "Asset Position",
                        heading: this.context.translate("_FLEET_CHAT_REPORT_"),
                      });
                      await this.setState({ loadData: 1 });
                    }}
                  />
                </Link>
              </>
            );
          },
        },
      ],
    };

    this.menuProps = {
      items: this.ExportOption,
      onClick: async (val) => {
        let result = [];

        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            interval: this.state.interval,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            userId: parseInt(
              JSON.parse(base64_decode(Cookies.get("data"))).userId
            ),
            // userId: 1,
            // userId:parseInt( this.state.userId),

            colList: result.toString(),
          };
          if (val.key == "excel") {
            await this.stoppageReportStore.exportExcel(getData);
            const isSuccess =
              this.stoppageReportStore?.pythonReportMessage === true;
            const isError = this.stoppageReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
          if (val.key == "csv") {
            this.stoppageReportStore.exportcsv(getData);
          }
          if (val.key == "pdf") {
            await this.stoppageReportStore.exportpdf(getData);
            const isSuccess =
              this.stoppageReportStore?.pythonReportMessage === true;
            const isError = this.stoppageReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
          if (val.key == "xml") {
            this.stoppageReportStore.exportxml(getData);
          }
        }
      },
    };

    this.newColumns = [...this.state.selectedColumns];
  }
  async componentDidMount() {
    const updates = {};

    const companySession = sessionStorage.getItem(
      "company_value_label_stoppageReport_session"
    );

    if (companySession) {
      const { company_value_label } = JSON.parse(companySession);

      updates.company_value_label = company_value_label;
      updates.companyId = company_value_label.value;

      await this.loadVehicles(company_value_label.value);


      // const groupSession = sessionStorage.getItem(
      //   "stoppageReport_deviceGroup_session"
      // );

      // if (groupSession) {
      //   const { deviceGroupIds } = JSON.parse(groupSession);

      //   if (deviceGroupIds?.length) {
      //     await this.vehicleStore.getReportsGroupVehicles({
      //       deviceGroupId: deviceGroupIds,
      //       deviceSubGroupId: null,
      //       companyId: company_value_label.value,
      //       userId: this.props.getUserData().userId,
      //       isadmin: 1,
      //       subgroup: deviceGroupIds,
      //     });
      //   } else {
      //     await this.vehicleStore.getVehiclesCompanyId(
      //       company_value_label.value
      //     );
      //   }
      // } else {
      //   await this.vehicleStore.getVehiclesCompanyId(
      //     company_value_label.value
      //   );
      // }

    }

    const vehicleSession = sessionStorage.getItem(
      "stoppageReport_vehicleId_session"
    );

    if (vehicleSession) {
      const { selectedVehicles } = JSON.parse(vehicleSession);
      updates.selectedVehicles = (selectedVehicles);
    }

    const vehicleAllSession = sessionStorage.getItem(
      "stoppageReport_vehicleId_All_session"
    );

    if (vehicleAllSession) {
      const { selectAllVehicles } = JSON.parse(vehicleAllSession);
      updates.selectAllVehicles = (selectAllVehicles);
    }

    const fromSession = sessionStorage.getItem(
      "stoppageReport_fromDate_session"
    );

    if (fromSession) {
      const { fromDate } = JSON.parse(fromSession);
      updates.fromDate = fromDate;
    }

    const toSession = sessionStorage.getItem(
      "stoppageReport_toDate_session"
    );

    if (toSession) {
      const { toDate } = JSON.parse(toSession);
      updates.toDate = toDate;
    }

    const intervalSession = sessionStorage.getItem(
      "stoppageReport_interval_session"
    );

    if (intervalSession) {
      const { interval } = JSON.parse(intervalSession);
      updates.interval = interval;
    }
    const gridTypeSession = sessionStorage.getItem(
      "stoppageReport_gridType_session"
    );

    if (gridTypeSession) {
      const { showtotaltable } = JSON.parse(gridTypeSession);

      updates.showtotaltable = showtotaltable;
      updates.showTable = !showtotaltable;
    }
    if (Object.keys(updates).length > 0) {
      this.setState(updates, async () => {
        if (this.state.selectAllVehicles) {
          await this.handleAllSelectVehicles();
        }
        await this.showData();

        if (this.state.showtotaltable) {
          await this.showTotal();
        }
      });
    }
    this.setState({ pageSize: 50 });
    await this.setState({ column: this.state.selectedColumns });

    this.totalStoppageReportCol = [
      {
        // title: "Asset Name ",
        title: this.context.translate(
          "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
        ),
        dataIndex: "vehicleNo",
        ellipsis: { showTitle: true },
        width: 15,
      },
      {
        // title: "From Date",
        title: this.context.translate("_FROM_DATE_"),
        dataIndex: "fromDate",
        ellipsis: { showTitle: true },
        width: 15,
      },
      {
        // title: "To Date",
        title: this.context.translate("_TO_DATE_"),
        dataIndex: "toDate",
        ellipsis: { showTitle: true },
        width: 15,
      },
      {
        // title: "Total Stoppage",
        title: this.context.translate("_TOTAL_STOPPAGE_"),
        dataIndex: "totalStopage",
        ellipsis: { showTitle: true },
        width: 15,
      },
      {
        // title: "Total Duration",
        title: this.context.translate("_TOTAL_DURATION_"),
        dataIndex: "totalDuration",
        ellipsis: { showTitle: true },
        width: 15,
      },
    ];
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;
      // console.log(companyId)
      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
      sessionStorage.setItem(
        "company_value_label_stoppageReport_session",
        JSON.stringify({
          company_value_label: {
            value: companyId,
          },
        })
      );
    }
    await this.setState({ loadData: 1 });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.vehicleObj !== prevState.vehicleObj) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }
  }
  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ companyId: comp?.value });
    // await this.setState({ selectedVehicles: [], selectAllVehicles: false });
    // await this.vehicleStore.getVehiclesCompanyId(comp?.value);
    await this.loadVehicles(comp?.value);
    await this.handleSearch();
  }

  getSavedGroupIds = () => {
    try {
      const s = sessionStorage.getItem("stoppageReport_deviceGroup_session");
      return s ? JSON.parse(s).deviceGroupIds || [] : [];
    } catch {
      return [];
    }
  };

  loadVehicles = async (companyId) => {
    const groupIds = this.getSavedGroupIds();
    if (groupIds.length) {
      await this.vehicleStore.getReportsGroupVehicles({
        deviceGroupId: groupIds,
        deviceSubGroupId: null,
        companyId,
        userId: this.props.getUserData().userId,
        isadmin: 1,
        subgroup: groupIds,
      });
    } else {
      await this.vehicleStore.getVehiclesCompanyId(companyId);
    }
  };
  async handleSearch() {
    this.setState({ loading: true });
    this.setState({ Notasset: false });
    // await this.stoppageReportStore.loadData({
    //   offset: (this.state.pageNo - 1) * this.state.pageSize,
    //   limit: this.state.pageSize,
    //   companyId: this.state.companyId,
    //   pageNo: this.state.pageNo,
    // });

    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination, "pagination");
    await this.setState({
      pageNo: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.showData();
  }

  // vehicleSelect = async (val) => {
  //   console.log(val);
  //   await this.setState({ selectedVehicles: val });
  // };

  showData = async () => {
    invalidateCache("stoppagereportlist");
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (this.state.interval === "") {
      this.setState({ Notinterval: true });
    } else {
      this.setState({ Notinterval: false });
    }
    if (!this.state.fromDate) {
      this.setState({ Notdate: true });
    } else {
      this.setState({ Notdate: false });
    }

    if (this.state.companyId && this.state.selectedVehicles.length > 0 && this.state.fromDate && this.state.toDate) {
      this.setState({ Notcompany: false, Notasset: false, Notinterval: false });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.stoppageReportStore.loadData({
          offset: (this.state.pageNo - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          vehicleId: this.state.selectedVehicles,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          interval: this.state.interval,
          pageNo: this.state.pageNo,
        });
        await this.setState({ loadData: 1 });
      }
    }
    // else if(this.vehicleStore?.getVehiclesUsingCompanyId) {
    //   await this.stoppageReportStore.loadData({
    //     offset: 0,
    //     limit: this.state.pageSize,
    //     companyId: this.state.companyId,
    //     vehicleId: this.state.selectedVehicles,
    //     interval: this.state.interval,
    //     pageNo: 1,
    //   });
    //   this.setState({pageNo:1})
    //   await this.setState({ loadData: 1 });
    // }
  };
  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        // fromDate: dates[0].format(format),
        // toDate: dates[1].format(format),
      });
      const fromDate = dates[0].format(format);
      const toDate = dates[1].format(format);
      this.setState({ fromDate, toDate });

      sessionStorage.setItem(
        "stoppageReport_fromDate_session",
        JSON.stringify({ fromDate })
      );

      sessionStorage.setItem(
        "stoppageReport_toDate_session",
        JSON.stringify({ toDate })
      );
    } else {
      this.setState({ fromDate: "", toDate: "" })
    }
  };

  addMonths = (date, months) => {
    // date.setMonth(date.getMonth() + months);
    // date = date + months;
    var indx = dayjs().month() + -6;
    // return date.format("YYYY-MM-DD HH:mm:ss");
    return dayjs().month(indx);
  };
  checkFromDate(dates) {
    //  var fromDate = dates.format("YYYY-MM-DD HH:mm:ss");
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      //  Ext.Msg.show({
      //      title: fleet.Language.get('_FLEET_ALERT_'),
      //      msg: fleet.Language.get('_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_'),
      //      buttons: Ext.Msg.OK,
      //  });
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  handleCheckboxChange = async (column) => {
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
    } else {
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
    }
  };

  showTotal = async () => {
    invalidateCache("totalStoppagereportlist");
    this.setState({ loadingData: true })
    await this.stoppageReportStore.totalStoppageReport({
      offset: (this.state.totalPageNo - 1) * this.state.totalPageSize,
      limit: this.state.totalPageSize,
      companyId: this.state.companyId,
      vehicleId: this.state.selectedVehicles,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      interval: this.state.interval,
    });
    await this.setState({ loadData: 1, loadingData: false });
  };

  refreshList = async () => {
    invalidateCache("stoppagereportlist");

    await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
    await this.showData();
  };
  triggerReport = () => {
    this.pythonMessageRef.current.show(); // show the modal
  };

  async handleTotalTableChange(pagination, filters, sorter) {
    await this.setState({
      totalPageNo: pagination.current,
      totalPageSize: pagination.pageSize,
    });
    await this.showTotal();
  }
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  value={
                    this.state.company_value_label
                      ? this.state.company_value_label
                      : null
                  }
                  allowClear={true}
                  onChange={(value) => {
                    this.setState({ selectedVehicles: [], selectAllVehicles: false });

                    this.handleChange(value);
                    sessionStorage.setItem('company_value_label_stoppageReport_session', JSON.stringify({
                      company_value_label: value
                    }));
                  }}
                  // onChange={this.handleChange}
                  className="searchInput"
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />
                {(this.props.getUserData().isadmin === 1 || this.props.getUserData().isadmin === 0) && (
                  <DeviceGroupsForVehicles
                    deviceGroupSessionKey="stoppageReport_deviceGroup_session"
                    vehicleStore={this.vehicleStore}
                    setLoadDta={() => this.setState({ loadData: 1 })}
                    loadDefaultVehicles={() =>
                      this.loadVehicles(
                        this.props.getUserData().userCompanyId
                      )
                    }
                    resetVehicles={() => {
                      try {
                        sessionStorage.removeItem("stoppageReport_vehicleId_All_session");
                        sessionStorage.removeItem("stoppageReport_vehicleId_session");
                      } catch { }
                      this.setState({
                        selectedVehicles: [],
                        selectAllVehicles: false,
                      })
                    }
                    }
                  />
                )}
                <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    sessionStorage.setItem('stoppageReport_vehicleId_All_session', JSON.stringify({
                      selectAllVehicles: e.target.checked,
                    }));
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                    });
                    // console.log(e.target.checked);
                    await this.handleAllSelectVehicles();
                  }}
                />

                {this.context.translate("_ALL_")}

                <Select
                  maxTagCount="responsive"
                  className="searchInput"
                  value={this.state.selectedVehicles}
                  onChange={(val) => {
                    sessionStorage.setItem('stoppageReport_vehicleId_session', JSON.stringify({
                      selectedVehicles: val
                    }));
                    this.setState({ selectedVehicles: val });
                    if (
                      this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                      val.length
                    ) {
                      sessionStorage.setItem('stoppageReport_vehicleId_All_session', JSON.stringify({
                        selectAllVehicles: false,
                      }));
                      this.setState({ selectAllVehicles: false });
                    } else {
                      sessionStorage.setItem('stoppageReport_vehicleId_All_session', JSON.stringify({
                        selectAllVehicles: true,
                      }));
                      this.setState({ selectAllVehicles: true });
                    }

                    if (val?.length > 1) {
                      this.setState({ showAlertPopup: true });
                    }
                  }}
                  style={{ width: 150 }}
                  showSearch
                  status={this.state.Notasset ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option key={val.vehicleId} value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>
                <RangePicker
                  value={
                    this.state.fromDate && this.state.toDate
                      ? [dayjs(this.state.fromDate), dayjs(this.state.toDate)]
                      : null
                  }
                  placeholder={[
                    this.context.translate("_FROM_DATE_TIME_"),
                    this.context.translate("_TO_DATETIME_"),
                  ]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 400, borderRadius: "25px" }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  // disabledDate={(current) => {
                  //   return current && current > dayjs();
                  // }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [dayjs().startOf("day"), dayjs()],
                  }}
                  status={this.state.Notdate ? "error" : false}
                  defaultValue={[dayjs().startOf("day"), dayjs()]}
                />
                <Input
                  style={{
                    width: 100,
                    borderRadius: "25px",
                  }}
                  value={this.state.interval}
                  placeholder={this.context.translate("_INTERVAL_")}
                  onChange={(e) => {
                    this.setState({ interval: e.target.value })
                    sessionStorage.setItem('stoppageReport_interval_session', JSON.stringify({
                      interval: e.target.value
                    }));
                  }}
                />
                <Button
                  type="primary"
                  onClick={async () => {
                    this.setState({ pageNo: 1 });
                    this.showData();
                    this.setState({ pageNo: 1 });
                    await this.setState({
                      showTable: true,
                      showtotaltable: false,
                    });
                    sessionStorage.setItem(
                      "stoppageReport_gridType_session",
                      JSON.stringify({
                        showtotaltable: false,
                      })
                    );
                  }}
                >
                  {/* Show */}
                  {this.context.translate("_FLEET_REPORTS_SHOWBTN_")}
                </Button>
                {conf.currentFlavor !== "nodeui" && <Button
                  onClick={async () => {
                    await this.showTotal();
                    await this.setState({
                      showTable: false,
                      showtotaltable: true,
                    });
                    sessionStorage.setItem(
                      "stoppageReport_gridType_session",
                      JSON.stringify({
                        showtotaltable: true,
                      })
                    );
                  }}
                >
                  {this.context.translate("_TOTAL_")}
                </Button>}

                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col span={4}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.stoppageReportStore?.stoppageReport?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.menuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          {conf.currentFlavor !== "nodeui" && <div className="accordion-list">
            {this.context.translate("_FLEET_REPORTS_STOPREPORT_TITLE_")}
            <Button
              onClick={() =>
                this.setState({
                  showTable: !this.state.showTable,
                  showtotaltable: !this.state.showtotaltable,
                })
              }
            >
              {this.state.showTable ? (
                <CaretDownOutlined />
              ) : (
                <CaretUpOutlined />
              )}
            </Button>
          </div>}

          {this.state.showTable && (
            <ListTable
              key={this.state.selectedColumns.length}
              currentPage={this.state.pageNo}
              pageSize={this.stoppageReportStore.pageSize}
              total={this.stoppageReportStore?.total}
              columns={this.state.selectedColumns}
              dataSource={
                this.stoppageReportStore?.stoppageReport?.length > 0 && [
                  ...this.stoppageReportStore?.stoppageReport,
                ]
              }
              loading={this.stoppageReportStore?.loading}
              onChange={this.handleTableChange}
              // showSizeChanger={false}
              // moreClass="gridNum"
              {...(conf.currentFlavor === "nodeui" && {
                showSizeChanger: false,
                moreClass: "gridNum",
              })}
            />
          )}

          {conf.currentFlavor !== "nodeui" && <div className="accordion-list">
            {" "}
            {this.context.translate("_TOTAL_STOP_REPORT_")}
            <Button
              onClick={() =>
                this.setState({
                  showtotaltable: !this.state.showtotaltable,
                  showTable: !this.state.showTable,
                })
              }
            >
              {this.state.showtotaltable ? (
                <CaretDownOutlined />
              ) : (
                <CaretUpOutlined />
              )}
            </Button>{" "}
          </div>}

          {/* <div
            style={{
              backgroundColor: "Transparent ",
              color: "#0090e7",
              fontSize: "16px",
              padding: "8px 8px",
              fontWeight: "600",
              marginTop: "8px",
              marginBottom: "5px",
            }}
          >
         
          </div> */}
          {conf.currentFlavor !== "nodeui" && this.state.showtotaltable && (
            <ListTable
              pageSize={this.state.totalPageSize}
              total={this.stoppageReportStore?.totalStoppageReportTotal}
              currentPage={this.state.totalPageNo}
              columns={this.totalStoppageReportCol}
              dataSource={this.stoppageReportStore?.stoppageArray}
              loading={this.stoppageReportStore?.loadingData}
              onChange={this.handleTotalTableChange}
              // pagination={false}
              // onChange={this.handleTableChange}
              summary={(records) => {
                var sum = 0;
                var suma = 0;

                records.map((record) => {
                  if (record.totalStopage) {
                    sum = parseInt(sum) + parseInt(record.totalStopage);
                  }

                  if (record.totalDuration) {
                    var dt = record.totalDuration.split(":");
                    var ts =
                      parseInt(dt[0] * 60 * 60) +
                      parseInt(dt[1] * 60) +
                      parseInt(dt[2]);
                    suma = parseInt(parseInt(suma) + parseInt(ts));
                  }
                });

                var d, h, m, s;

                s = suma;
                m = Math.floor(s / 60);
                s = s % 60;
                h = Math.floor(m / 60);
                m = m % 60;
                d = Math.floor(h / 24);
                h = h % 24;

                var result = (d < 10 ? "0" + d : d) + " days,";
                result += h < 10 ? "0" + h : h;
                result += ":" + (m < 10 ? "0" + m : m);
                result += ":" + (s < 10 ? "0" + s : s);

                return (
                  <>
                    {records.length != 0 && (
                      <Table.Summary.Row>
                        <Table.Summary.Cell>
                          <Text style={{ fontWeight: "bold" }}>Total</Text>
                        </Table.Summary.Cell>

                        <Table.Summary.Cell />
                        <Table.Summary.Cell />

                        <Table.Summary.Cell>
                          <Text style={{ fontWeight: "bold" }}>{sum}</Text>
                        </Table.Summary.Cell>

                        <Table.Summary.Cell>
                          <Text style={{ fontWeight: "bold" }}>{result}</Text>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    )}
                  </>
                );
              }}
            />
          )}
        </div>

        {this.state.vehicleObj && (
          <MapForVehiclePosition
            vehicleObj={this.state.vehicleObj}
            heading={this.state.heading}
            closeMapModal={(resp) => {
              this.setState({ vehicleObj: resp });
            }}
          />
        )}

        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {/* For reports prior to 6 months please contact administrator */}
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>
        {
          <div>
            <PythonMessageAlert
              ref={this.pythonMessageRef}
              message={this.state.reportmessage}
            />
          </div>
        }
      </>
    );
  }
}
StoppageReportList.contextType = StoreContext;
export default observer(withRouter(StoppageReportList));
